import styled, { css } from 'styled-components';
import { theme } from './theme';
import { common, flex, space, typography, border } from './setting';

export const mixed = css`
  ${common}
  ${space}
  ${flex}
  ${border}
`;

export const Div = styled.div`
  ${mixed}
`;

export const CardDiv = styled(Div)`
  border-radius: 8px;
  box-shadow: ${theme.shadows.card};
`;

export const RowDiv = styled(Div)`
  display: flex;
`;

export const CenterRowDiv = styled(RowDiv)`
  align-items: center;
`;

export const ColDiv = styled(Div)`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  padding: 12px 12px 88px;
  ${mixed};
`;

export const Article = styled.article`
  ${mixed}
`;

// ul,li
export const RowList = styled.ul`
  ${mixed}
  display: flex;
`;

export const ColList = styled.ul`
  ${mixed}
  display: flex;
  flex-direction: column;
`;

export const List = styled.ul`
  ${mixed}
`;

export const ListItem = styled.li`
  ${mixed}
`;

export const RowListItem = styled.li`
  ${mixed}
  display: flex;
`;

export const ColListItem = styled.li`
  ${mixed}
  display: flex;
  flex-direction: column;
`;

export const H2 = styled.h2`
  ${mixed}
  ${typography}
`;

export const H3 = styled.h3`
  ${mixed}
  ${typography}
`;

export const H4 = styled.h4`
  ${mixed}
  ${typography}
`;

export const H5 = styled.h5`
  ${mixed}
  ${typography}
`;

export const Text = styled.p`
  ${mixed}
  ${typography}
`;

export const Span = styled.span`
  ${mixed}
  ${typography}
`;

export const Line = styled.span`
  ${mixed}
  display: block;
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.gray100};
`;
